import on from "delegated-events";

export class RadioCard {
  cssClass = "c-radiocard";
  #activeClass = "--active";
  #checkBox = null;
  #groupId = null;
  #isGrouped = false;
  #isActive = false;
  #radio = null;

  constructor(el = null) {
    this.el = el;
    this.#checkBox = this.el.querySelector("[data-checkbox]");
    this.#radio = this.el.querySelector("[data-radio]");
    this.#groupId = this.el.dataset.groupId ?? null;
    if(this.el.classList.contains(this.#activeClass)){
      this.makeActive();
    }
    if( this.#groupId !== null ){
      this.#isGrouped = true;
    }
    this.init();
  }

  get isActive(){
    return this.#isActive;
  }

  makeActive(){
    if( this.#isGrouped ){
      this.#clearGroupActive();
    }
    this.#checkBox.checked = true;
    this.#radio.checked = true;
    this.el.classList.add(this.#activeClass);
    this.#isActive = true;
  }

  disableActive(){
    this.#checkBox.checked = false;
    this.#radio.checked = false;
    this.el.classList.remove(this.#activeClass);
    this.#isActive = false;
  }

  #clearGroupActive(){
    document.querySelectorAll(`.${this.cssClass}[data-group-id=${this.#groupId}]`).forEach( element => {
      element.instance.disableActive();
    });
  }

  #toggleActive(){
    if( this.#isActive ){
      this.disableActive();
    }else{
      this.makeActive();
    }
  }

  init(){
    this.el.addEventListener("click", () => {
      this.#toggleActive();
    });
  }

}